import React, { ElementType, PropsWithChildren, useEffect, useState } from 'react';
import { Image } from 'react-frontier';
import classNames from 'classnames';

type CardProps<E extends ElementType> = {
	selectable?: boolean,
	placeholder?: boolean
	placeholderImage?: boolean,
	className?: string,
	image?: string,
	imageFallback?: string,
	imageFallbackIcon?: string,
	onClick?: ()=>void,
	as?: E,
	style?: React.CSSProperties,
	empty?: boolean,
	[x: string]: any
} & PropsWithChildren

var Card = <E extends ElementType>(props: CardProps<E>)=>{
	var {
		image,
		imageFallback,
		imageFallbackIcon,
		as,
		className,
		onClick,
		style,
		empty,
		selectable,
		...restProps
	} = props;

	if(props.placeholder){
		return <div className={classNames("tp card placeholder", className)} style={props.style}>
			{props.placeholderImage && (
				<div className="image"></div>
			)}
			<div className="info">
				{props.children}
			</div>
		</div>
	}
	
	const ComponentType = props.as ?? 'div';
	return <ComponentType className={classNames("tp card", className, {
		selectable: props.selectable!==false,
	})} onClick={onClick} style={props.style} {...restProps}>
		{!!props.image && (
			<div className="image">
				<Image src={props.image} fallback={imageFallback} fallbackComponent={imageFallbackIcon ? (
					<i className={classNames('icon', imageFallbackIcon)} />
				) : null} />
			</div>
		)}
		<div className={classNames("info", { empty })}>
			{props.children}
		</div>
	</ComponentType>
}

export default Card;